import { useState } from 'react';
import lo from 'lodash';

const useData = data => {
  const [state, setState] = useState(data);
  const modify = newParams =>
    setState(old =>
      lo.mergeWith({}, old, newParams, (_, src) => {
        if (lo.isArray(src)) {
          return src;
        }
      }),
    );
  return [state, modify];

  // cannot use merge as empty [] won't override the old value
};

export default useData;
